import { createFileRoute, Outlet } from "@tanstack/react-router";

/** News: the list, a new item, and one item's page. */
export const Route = createFileRoute("/_app/growth/news")({
  component: Outlet,
});
